import { replaceWidgetsInContent, WidgetType } from '@shared-utils';
import { environment } from 'environments';

(() => {
  angular.module('pims').filter('widgetFilter', [
    'localStorageService',
    localStorageService => {
      'ngInject';
      const localCache = new Map();
      const app = environment.constants.app_name;
      const services = localStorageService.get('pimsParameters')?.pimsWidgets?.servicesPlaceholderValue || {
        WEI: 'WL',
        // We add other widget placeholder name here i.e ACN: 'ACN',
      };
      const widgetsConfig = {
        [WidgetType.REFILL]: { permissions: ['clinician'], enabled: true, previewToken: true },
        [WidgetType.REFILL_RESPONSE]: { permissions: ['patient'], enabled: true },
        [WidgetType.WL_FILE_UPLOAD]: { permissions: ['clinician'], enabled: true, previewToken: true },
      };

      return message => {
        if (!message.content || typeof message.content !== 'string') return message.content;
        const cacheKey = message.id;

        if (localCache.has(cacheKey)) {
          return localCache.get(cacheKey);
        }
        const { content, to, id } = message;
        const messageCopy = { ...message };
        const newMessageContent = replaceWidgetsInContent(content, to.id, widgetsConfig, id, app);
        const replaced = { ...messageCopy, content: newMessageContent };
        localCache.set(cacheKey, replaced);
        return replaced;
      };
    },
  ]);
})();
